export default "__VITE_ASSET__CawWShpw__"